"use client";
import { Language } from '@/projectRoot/routes.config';
import style from './broadcastEntity.module.scss';
import { useLocale } from 'next-intl';
import CubesImage from '../../general/cubes-image/CubesImage';
import LinkUrl from '../../general/link/LinkUrl';
import BroadcastEntityDto from '@/projectRoot/api-client/interfaces/models/broadcast/BroadcastEntity.dto';

interface Props {
    entity: BroadcastEntityDto;
    classes?: string[];
}

const BroadcastEntity = ({entity, classes = []}: Props) => {
    const locale = useLocale();
  return (
    <div className={`${style.entity} ${classes.join(' ')}`}>
        <LinkUrl url={entity.multilang_slugs[locale]} classes={[style.image, 'imgPlaceholder']}>
            <CubesImage imageNarrow={entity.image_src} alt={entity.title[locale]} width={200} height={150} />
        </LinkUrl>
        <LinkUrl url={entity.multilang_slugs[locale]} classes={[style.title]}>
            {entity.title[locale]}
        </LinkUrl>
        <p className={style.description}>
            {entity.description[locale]}
        </p>
    </div>
  )
};

export default BroadcastEntity;
